import React from "react";
import Body3 from "../../../components/typography/body-03";
import styles from "./QuickPricerFooter.module.scss";

const QuickPricerFooter = () => {
	return (
		<div className={styles.footerBar}>
			<Body3
				text="© Copyright 2012 - 2026 | Logan Finance Corporation | All Rights Reserved | NMLS 127722"
				extraClass={styles.footerText}
			/>
		</div>
	);
};

export default QuickPricerFooter;
